import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axiosInstance from "./axiosInstance";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faClose,
  faCogs,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import DataTable from "react-data-table-component";
import TableStyle1 from "./TableStyle";
import { Modal } from "react-bootstrap";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { start } from "nprogress";

const Groups = () => {
  const sweetAlert = withReactContent(Swal);

  const [groups, setGroups] = useState([]);

  const [rowSelected, setRowSelected] = useState([]);
  const [toggleSelection, setToggleSelection] = useState(false);

  const [searchResult, setSearchResult] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  useEffect(() => {
    const result = groups.filter((row) => {
      return row.name.toLowerCase().includes(searchQuery.toLowerCase());
    });
    setSearchResult(result);
  }, [searchQuery]);

  const fetchGroups = () => {
    axiosInstance
      .get("/groups/get", { timeout: 10000 })
      .then((response) => {
        setGroups(response.data);
      })
      .catch((error) => {});
  };

  const handleSelectedRow = ({ selectedRows }) => {
    setRowSelected(selectedRows);
  };

  const deleteUsers = () => {
    axiosInstance
      .post(
        "/groups/delete",
        rowSelected.map((item) => item.id),
        { timeout: 10000 }
      )
      .then((response) => {
        setToggleSelection(!toggleSelection);
        fetchGroups();
      })
      .catch((error) => {});
  };

  const contextAction = (
    <button className="btn" type="button" onClick={() => deleteUsers()}>
      <FontAwesomeIcon icon={faTrash} />
    </button>
  );

  const columns = [
    {
      name: "Name",
      cell: (row) => <span className="row-title">{row.name}</span>,
    },
  ];

  useEffect(() => {
    fetchGroups();
  }, []);
  return (
    <>
      <div className="card shadow-none d-flex flex-row align-items-center">
        <div className="input-group border-0 mr-2">
          <div className="input-group-prepend border-0">
            <span className="input-group-text border-0">
              <i className="material-icons">search</i>
            </span>
          </div>
          <input
            type="text"
            className="form-control border-0"
            placeholder="Search"
            aria-label="Search"
            onChange={handleSearch}
          />
        </div>

        <Link
          type="button"
          className="ml-auto btn btn-round mr-1 shadow"
          to={"/groups/set"}
        >
          <FontAwesomeIcon icon={faPlus} />
        </Link>
      </div>

      <div className="card shadow-none mt-4 box-shadow">
        <DataTable
          title={`Employee Groups`}
          columns={columns}
          data={searchQuery.length > 1 ? searchResult : groups}
          customStyles={TableStyle1}
          selectableRows
          pagination
          paginationPerPage={5}
          onSelectedRowsChange={handleSelectedRow}
          clearSelectedRows={toggleSelection}
          contextActions={contextAction}
        />
      </div>
    </>
  );
};

export default Groups;
